/* eslint-disable */
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import { orderBy } from 'lodash';
import moment from 'moment';
import { useHistory, useParams } from 'react-router-dom';
import { useMutation, useQueryClient } from 'react-query';
import { Chip } from '@material-ui/core';
import jwt_decode from 'jwt-decode';
import formatDropdownOptions, {
  buildCompanySearchLabel,
  buildVesselDropdownLabel,
  buildVesselSearchLabel
} from '../../utils/formatDropdownOptions';
import DropdownFieldComponent from '../common/FormComponents/DropdownFieldComponent';
import InputFieldComponent from '../common/FormComponents/InputFieldComponent';
import withMasterData from '../MasterComponent';
import VesselForm from './VesselForm';
import getPortList from './queries/getPortList';
import getPaymentTerms from './queries/getPaymentTerms';
import getExpenseCategoryJSONlist from './queries/getExpenseCategoryJsonList';
import addPO from './queries/addPO';
import polygon from '../../images/icons/polygon.svg';
import showAlert from '../../utils/alert';
import removeEmpty from '../../utils/removeEmptyValuesFromObject';
import Loader from '../common/Loading';
import editPO from './queries/editPO';
import getCurrencyList from '../vendor/queries/getCurrency';
import getLevelOnePurpose from './queries/getLevelOnePurpose';
import getLevelTwoPurpose from './queries/getLevelTwoPurpose';
import getVesselList from './queries/getVesselList';
import getDefaultCrew from './queries/getDefaultCrew';
import fetchCompanyList from './queries/getCompanyListByVessel';
import GetDuplicatePO from './queries/getDuplicatePO';
import saveSendPurchaseOrder from './queries/saveSendPurchaseOrder';
import sendPOQuery from './queries/sendPO';
import DuplicateSave from '../Modal/DuplicateSave';
import getVendorQuery from './queries/getVendorCategory';
import getVendorExpenseQuery from './queries/getVendorExpenseItem';
import MailModal from '../Modal/MailModal';
import formatDropdownOptionsVendor, { buildVendorSearchLabel } from '../../utils/formatDropdownOptionsVendor';
import getCompanyList from '../vendor/queries/getCompanyList';
import axios from '../../utils/axios';
import { apiurl } from '../../config/apiUrl';
import fetchExpenseItems from '../expenseItem/queries/fetchExpenseItems';
import { Button} from '@synergy-marine-group/synergy-ui';
import checkPOBudgetType from './queries/checkPOBudgetType';
import { SYSTEM_GENERATED_CATEGORY_LIST } from './utils';
import PoAttachments from './PoAttachments';
import AdvanceRequest from './AdvanceRequest';
import ApprovalFlowLog from './ApprovalFlowLog';
import getAdvanceRequestPurchaseOrder from './queries/getAdvanceRequestPurchaseOrder';
import getLevel2ApproverList from './queries/getLevel2ApproverList';
import getAgencyPOConfig from './queries/getAgencyPOConfig';
import postAdvancePoCancellation from './queries/postAdvancePoCancellation';
import Level2Approver from './Level2Approver';

const budgetCategoryList = [
  { label: 'BUDGETED CATEGORY', value: 'BUDGETED CATEGORY' },
  { label: 'NON-BUDGETED CATEGORY', value: 'NON BUDGETED CATEGORY' },
  { label: 'PRE-DELIVERY CATEGORY (TAKEOVER)', value: 'PRE DELIVERY CATEGORY' },
  { label: 'HANDOVER CATEGORY', value: 'HANDOVER CATEGORY' },
  { label: 'DRY DOCK', value: 'DRY DOCK' },
  { label: 'OTHERS', value: 'OTHERS' }
];

const eqGuid = (a, b) => {
  if (a == null || b == null || a === '' || b === '') return false;
  return String(a).trim().toLowerCase() === String(b).trim().toLowerCase();
};

/** Same vessel id can map to multiple revisions (e.g. WOPR vs WPRZ). Prefer revision, then id+code. */
const resolveAgencyHeaderVessel = (values, list, dataObj, poVesselOption) => {
  const revisionId = values?.plannedVesselRevisionId;
  if (revisionId && list?.length > 0) {
    const byRevision = list.find(
      (v) => eqGuid(v.value, revisionId) || eqGuid(v.vesselRevisionId, revisionId)
    );
    if (byRevision) return byRevision;
  }
  const plannedId = values?.plannedVesselId;
  const vesselCode = String(values?.vesselCode || dataObj?.vesselCode || '').trim();
  if (plannedId != null && plannedId !== '' && list?.length > 0) {
    if (vesselCode) {
      const byIdAndCode = list.find(
        (v) => String(v?.id ?? '') === String(plannedId)
          && String(v?.vesselCode ?? '').trim().toUpperCase() === vesselCode.toUpperCase()
      );
      if (byIdAndCode) return byIdAndCode;
    }
    const sameId = list.filter((v) => String(v?.id ?? '') === String(plannedId));
    if (sameId.length === 1) return sameId[0];
  }
  if (poVesselOption && (poVesselOption.value || poVesselOption.id)) return poVesselOption;
  return null;
};

const mapArqFromApi = (source) => {
  if (!source) return [];
  const arr = Array.isArray(source) ? source : [source];
  return arr.map((item, i) => {
    const dateVal = item?.proformaInvoiceDate;
    const dateStr = dateVal ? (moment(dateVal).isValid() ? moment(dateVal).format('YYYY-MM-DD') : dateVal) : '';
    const attachments = item?.arqAttachments ?? item?.advanceAttachments ?? [];
    const rawPaymentTerms = item?.paymentTermsId ?? item?.paymentTerms ?? '';
    return {
      id: item?.id || `adv-${Date.now()}-${i}`,
      purchaseOrderId: item?.purchaseOrderId,
      paymentTermsId: rawPaymentTerms != null && rawPaymentTerms !== '' ? String(rawPaymentTerms) : '',
      advanceAmount: item?.advanceAmount != null ? item.advanceAmount : '',
      proformaInvoiceNo: item?.proformaInvoiceNo ?? '',
      proformaInvoiceDate: dateStr,
      remarks: item?.remarks ?? item?.advanceRemarks ?? '',
      status: item?.status,
      arqSeqNo: item?.arqSeqNo ?? 0,
      arqAttachmentIds: item?.arqAttachmentIds ?? [],
      arqAttachments: attachments,
      arqNumber: item?.arqNumber,
      sapArqNumber: item?.sapArqNumber
    };
  });
};

const AgencyPOForm = ({ dataObj, setisLoading, setisduplicateloading, setDraft, isDraft, mode, isFetchingPo, expenseItemList, restoredPpeCategoryDetails, setRestoredPpeCategoryDetails, poId: poIdProp }) => {
  const history = useHistory();
  const { poId: poIdFromParams } = useParams();
  const poId = poIdProp ?? poIdFromParams;
  const editVesselSyncedRef = useRef(false);
  const { data: arqQueryResponse, refetch: refetchArq } = getAdvanceRequestPurchaseOrder(poId, { enabled: !!poId });
  const arqListFromApi = (() => {
    const raw = arqQueryResponse?.data;
    if (Array.isArray(raw)) return raw;
    if (raw && Array.isArray(raw.data)) return raw.data;
    if (raw && Array.isArray(raw.result)) return raw.result;
    return [];
  })();
  const [saveModal, setSaveModal] = useState(false);
  const [formValues, setformValues] = useState(null);
  const [vendorAddress, setAddress] = useState(null);
  const [expenseitemsData, setexpenseitemsData] = useState([]);
  const [filteredVendorList, setfilteredVendorList] = useState([]);
  const [initialDataLoaded, setinitialDataLoaded] = useState(true);
  const [checkOutDataLoaded, setcheckOutDataLoaded] = useState(true);
  const [duplicateData, setduplicateData] = useState([]);
  const [openHeader, setopenHeader] = useState(true);
  const [airfareOpen, setairfareOpen] = useState(null);
  const [mailModal, setMailModal] = useState(false);
  const [editPoValues, setEditPoValues] = useState(null);
  const [disableHeader, setdisableHeader] = useState(false);
  const [mailBasicInfo, setmailBasicInfo] = useState({ to: [], cc: [], subject: 'Purchase Order is created', isCustomSubject: true });
  const [mailVendorList, setMailVendorList] = useState([]);
  const [currencyList, setCurrencyList] = useState([]);
  const [defaultCrewData, setDefaultCrewData] = useState(null);
  const defaultCrewUuidRef = useRef(null);
  const [selectedDefaultCrewData, setSelectedDefaultCrewData] = useState(null);
  const [savedaccountCode, setSavedAccountCode] = useState(null);
  const [companyId, setCompanyId] = useState();
  const [createdAccountCode, setcreatedAccountCode] = useState();
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [pendingValues, setPendingValues] = useState(null);
  const [level2ApproverParams, setLevel2ApproverParams] = useState({});
  const isCrewPage = true;

  const oldVendorId = dataObj?.vendorId;
  const OldExpenseCategoryId = dataObj?.expenseCategoryId;

  const filterAndFillExpItm = (item) => {
    let flag = true;
    const crew = Array.isArray(dataObj?.purchaseOrderCrew) ? dataObj?.purchaseOrderCrew?.[0] : dataObj?.purchaseOrderCrew;
    item?.find((val) => {
      if (val.label === crew?.expenseLineItem && flag) {
        flag = false;
      }
    });
    return flag;
  };

  const {
    isLoading: expenseCategoryLoading,
    data: expenseCategory
  } = getExpenseCategoryJSONlist();
 
  const filteredExpenseCategoryData = expenseCategory?.data?.filter((item) => {
    const isSystemGenerated = SYSTEM_GENERATED_CATEGORY_LIST.includes(item.categoryName);
    const isSelectedSystemGenerated = SYSTEM_GENERATED_CATEGORY_LIST.includes(dataObj?.expenseCategoryName);
     
    // Agency PO: show only categories where poCategory includes 2
    const hasPoCategory2 = Array.isArray(item.poCategory)
      ? item.poCategory.includes(2)
      : item.poCategory === 2;
   if (!hasPoCategory2) return false;
    // Exclude system-generated categories unless the selected one itself is system-generated
    if (isSystemGenerated && (mode === 'add' || (mode === 'edit' && !isSelectedSystemGenerated))) {
      return false;
    }
    // Agency PO dropdown: show all categories; pocategory 2 is sent in API payload only when submitting
    return true;
  });
  const expenseCategoryList = formatDropdownOptions(filteredExpenseCategoryData, 'categoryName', 'expenseCategoryID');

  const validationSchema = Yup.object({
    expenseCategoryId: Yup.string().required('Please select the Category'),
    vendorId: Yup.string().required('Please select the Vendor'),
    currencyId: Yup.number().nullable().required('Please enter the Currency'),
    companyId: Yup.number()
    .typeError('Please select the Company')
    .required('Please select the Company'),    
    description: Yup.string().trim().max(250, 'Must be 250 characters or less').nullable(),
    purchaseOrderCrew: Yup.array(
      Yup.object().shape({
        plannedVesselId: Yup.string().nullable(),
        serviceCompletionDate: Yup.date().nullable(),
        expenseLineItemId: Yup.string().required('Please select the Expense Item'),
        amount: Yup.number().moreThan(0, 'Please enter a more than 0 value Amount').required('Please enter a valid Amount').nullable(),
        ppeDeliveryRemarks: Yup.string().when('expenseLineItemId', {
          is: (val) => {
             return false;
//   const ppeKitValue = expenseitemsData?.find(({ label }) => label === 'PPE KIT')?.value;
//   const ppeKitExpenseCategoryID = expenseitemsData?.find(({ label }) => label === 'PPE KIT')?.expenseCategoryID;
//   const ppeValue = expenseCategoryList?.find(({ label }) => label === 'PPE')?.value;
//   return val === ppeKitValue && ppeKitExpenseCategoryID === ppeValue;
},
          then: Yup.string().required('Please enter the Delivery Remarks').trim().max(250, 'Must be 250 characters or less').nullable(),
          otherwise: Yup.string().nullable(),
        }),
        ppeCategoryDetails: Yup.array().when('expenseCategoryId', {
          is: (val) => {
             return false;
            // const vesselPpeId = expenseCategoryList?.find(
            //   ({ label }) => label === 'Vessel PPE' || label === 'PPE'
            // )?.value;
            // return val === vesselPpeId;
          },
          then: Yup.array()
            .min(1, 'Please add at least one PPE item')
            .required('Please add at least one PPE item'),
          otherwise: Yup.array().nullable(),
        }),
      })
    ),
    // EndSession should greater than StartSession
    EndSession: Yup.date().when('StartSession', (StartSession, schema) => {
      if (StartSession) {
        return schema.min(StartSession, 'End Session should be greater than Start Session');
      }
    }),
    // dateOfService: Yup.array(
    //   Yup.object().shape({
    //     dateOfServices: Yup.string().required('Please add a Date '),
    //   })
    // ),
  });
  const { data: companies, mutate: getCompanyByCategory } = getCompanyList();
  const baseCompanyList = formatDropdownOptions(companies?.data, 'name', 'id') || [];
  const companyList = baseCompanyList.map((item, index) => {
    const safeItem = item || {};
    const rawCompany = companies?.data?.[index];
    const companyName = rawCompany?.name || safeItem?.name || safeItem?.label || '';
    const sapCompanyCode = rawCompany?.sapCompanyCode;
    const label = sapCompanyCode ? `${companyName} (${sapCompanyCode})` : companyName;
    return {
      ...safeItem,
      label,
      name: companyName,
      searchLabel: buildCompanySearchLabel(companyName, sapCompanyCode),
      sapCompanyCode: sapCompanyCode ?? safeItem?.sapCompanyCode
    };
  });

  const { data: currencies } = getCurrencyList();
  const { data: paymentTermsData } = getPaymentTerms();
  const { data: ports, isLoading: portsLoading } = getPortList({
    searchCriteria: '',
    Page: 1,
    PageSize: 500
  });
  const rawPortArray =
    ports?.data?.items ||
    ports?.data?.data ||
    ports?.data?.result ||
    ports?.data ||
    [];
  const portList = formatDropdownOptions(rawPortArray, 'name', 'identifier');
  const { mutate: checkBudgetType, isLoading: isCheckBudgetLoading } = checkPOBudgetType();

  const { mutate: addPurchaseOrder,
    isSuccess: isAddSuccess, isError: isAddError,
    reset: resetAdd, isLoading: isAddLoading } = addPO();
  const {
    mutate: sendPurchaseOrder,
    isSuccess: issendPurchaseOrderSuccess,
    isError: issendPurchaseOrderError,
    reset: resetsendPurchaseOrder,
    isLoading: issendPurchaseOrderLoading,
  } = saveSendPurchaseOrder();

  const {
    mutate: editPurchaseOrder,
    isSuccess: isEditSuccess,
    isError: isEditError,
    reset: resetEdit,
    isLoading: isEditLoading
  } = editPO();

  const { data: company, isLoading: getCompanyDataLoading } = fetchCompanyList();

  const { data: vessels, mutate: getVesselData } = getVesselList();
  const baseVesselList = formatDropdownOptions(vessels?.data, 'name', 'vesselRevisionId', 'vesselCode', true) || [];
  const vesselRawByRevisionId = new Map(
    (vessels?.data || []).map((v) => [String(v?.vesselRevisionId || '').toLowerCase(), v])
  );
  const vesselList = baseVesselList.map((item) => {
    const safeItem = item || {};
    const lookupKey = String(safeItem?.value || safeItem?.vesselRevisionId || '').toLowerCase();
    // Resolve by revision id only. Same vessel id (e.g. 620) can have multiple revisions
    // with different SAP codes; id fallback would attach the wrong revision's code.
    const raw = vesselRawByRevisionId.get(lookupKey) || {};
    const vesselName = raw?.name || safeItem?.name || '';
    const vesselCode = raw?.vesselCode || safeItem?.vesselCode || '';
    const sapVesselCompanyCode = raw?.sapVesselCompanyCode
      ?? safeItem?.sapVesselCompanyCode
      ?? '';
    const status = raw?.status ?? safeItem?.status;
    return {
      ...safeItem,
      name: vesselName,
      vesselCode,
      status,
      label: buildVesselDropdownLabel(vesselName, vesselCode, sapVesselCompanyCode, status),
      searchLabel: buildVesselSearchLabel(vesselName, vesselCode, sapVesselCompanyCode, status),
      vesselRevisionId: raw?.vesselRevisionId || safeItem?.vesselRevisionId || safeItem?.value,
      id: raw?.id ?? safeItem?.id,
      sapVesselCompanyCode
    };
  });

  const poVesselFromDataObj = useMemo(() => {
    if (mode !== 'edit' || !dataObj) return null;
    const firstCrew = dataObj?.purchaseOrderCrew?.[0];
    const revisionId = dataObj?.plannedVesselRevisionId ?? firstCrew?.plannedVesselRevisionId ?? '';
    const plannedId = dataObj?.plannedVesselId ?? firstCrew?.plannedVesselId ?? '';
    const vesselName = dataObj?.vesselName ?? firstCrew?.vesselName ?? firstCrew?.plannedVesselName ?? '';
    const vesselCode = dataObj?.vesselCode ?? firstCrew?.vesselCode ?? firstCrew?.plannedVesselCode ?? '';
    const imoNumber = dataObj?.imo ?? firstCrew?.imo ?? firstCrew?.imoNumber ?? '';
    const sapVesselCompanyCode = dataObj?.sapVesselCompanyCode ?? firstCrew?.sapVesselCompanyCode ?? '';
    if (!revisionId && !plannedId && !vesselName) return null;
    return {
      value: revisionId || String(plannedId),
      vesselRevisionId: revisionId,
      id: plannedId,
      name: vesselName,
      vesselCode,
      imoNumber,
      sapVesselCompanyCode,
      label: buildVesselDropdownLabel(vesselName, vesselCode, sapVesselCompanyCode),
      searchLabel: buildVesselSearchLabel(vesselName, vesselCode, sapVesselCompanyCode)
    };
  }, [mode, dataObj]);

  const vesselListForSelect = useMemo(() => {
    if (!poVesselFromDataObj?.value && !poVesselFromDataObj?.id) return vesselList;
    const inList = vesselList.some(
      (v) => eqGuid(v.value, poVesselFromDataObj.value)
        || eqGuid(v.vesselRevisionId, poVesselFromDataObj.vesselRevisionId)
    );
    if (inList) return vesselList;
    return [poVesselFromDataObj, ...vesselList];
  }, [vesselList, poVesselFromDataObj]);

  useEffect(() => {
    editVesselSyncedRef.current = false;
  }, [poId, dataObj?.id]);

  const { data: purposeLevelOne, isLoading: purposeLevelOneLoading } = getLevelOnePurpose();
  const purposeLevelOneList = formatDropdownOptions(purposeLevelOne?.data, 'purposeName', 'purposeID');
  const { mutate: getLevelTwoPurposeData,
    data: purposeLevelTwo } = getLevelTwoPurpose();
  const purposeLevelTwoList = formatDropdownOptions(purposeLevelTwo?.data, 'purposeName', 'purposeID');

  const { mutate: GetDuplicatePOEx, data: duplicate } = GetDuplicatePO();
  const { mutate: cancelAdvancePo, isLoading: isCancelAdvancePoLoading } = postAdvancePoCancellation();

  const { data: agencyPOConfigResponse } = getAgencyPOConfig(level2ApproverParams);
  const agencyPOConfig = (() => {
    const raw = agencyPOConfigResponse?.data;
    if (raw && typeof raw === 'object' && 'isAdvanceRequestAvailable' in raw) return raw;
    if (raw?.data && typeof raw.data === 'object') return raw.data;
    return null;
  })();

  const { data: level2ApproverResponse, isLoading: level2ApproverLoading } = getLevel2ApproverList(level2ApproverParams);
  const level2ApproverList = (() => {
    const raw = level2ApproverResponse?.data;
    if (Array.isArray(raw)) return raw;
    if (raw && Array.isArray(raw?.data)) return raw.data;
    if (raw && Array.isArray(raw?.result)) return raw.result;
    return [];
  })();

  const level2IdFromApprover = (approver) => {
    if (approver == null) return '';
    if (typeof approver === 'string') return approver;
    if (typeof approver === 'number') return String(approver);
    if (typeof approver === 'object') {
      return approver?.id ?? approver?.value ?? approver?.userId ?? approver?.user?.id ?? approver?.user?.value ?? '';
    }
    return '';
  };
  const level2IdNormalize = (id) => String(id ?? '').trim().toLowerCase();

  const level2ApproverOptions = useMemo(() => {
    const toGuid = (v) => {
      if (v == null) return '';
      if (typeof v === 'string') return v;
      if (typeof v === 'number') return String(v);
      if (typeof v === 'object') return v?.id ?? v?.value ?? '';
      return '';
    };
    const list = level2ApproverList || [];
    const options = list.map((item) => {
      const id = toGuid(item?.id);
      const normalized = level2IdNormalize(id);
      return {
        label: item.name && item.email ? `${item.name} (${item.email})` : (item.name || item.email || id),
        value: normalized || id
      };
    });
    const fromListIds = new Set(options.map((o) => o.value));
    const poApprover = dataObj?.level2Approver;
    const poApproverIdRaw = dataObj?.level2ApproverId ?? level2IdFromApprover(poApprover);
    const poApproverId = level2IdNormalize(poApproverIdRaw) || poApproverIdRaw;
    if (poApprover && poApproverId && !fromListIds.has(poApproverId)) {
      const isObjectWithName = typeof poApprover === 'object' && (poApprover?.name != null || poApprover?.email != null);
      const name = poApprover?.name ?? '';
      const email = poApprover?.email ?? '';
      const label = isObjectWithName
        ? (name && email ? `${name} (${email})` : (name || email || 'Select approver'))
        : 'Select approver';
      options.push({ label, value: poApproverId });
    } else if (poApproverId && !fromListIds.has(poApproverId)) {
      options.push({ label: 'Select approver', value: poApproverId });
    }
    return [{ label: 'Select', value: '' }, ...options];
  }, [level2ApproverList, dataObj?.level2Approver, dataObj?.level2ApproverId]);

  const buildVendorDropdownLabel = (vendorCode, vendorName, sapVendorCode) => {
    const code = (vendorCode && String(vendorCode).trim()) || '';
    const name = (vendorName && String(vendorName).trim()) || '';
    const sap = (sapVendorCode != null && String(sapVendorCode).trim() !== '') ? String(sapVendorCode).trim() : '';
    if (code && name && sap) return `${code} - ${name} (${sap})`;
    if (code && name) return `${code} - ${name}`;
    if (name && sap) return `${name} (${sap})`;
    return name || code || '-';
  };

  const filterCategoryvendor = (data) => {
    const options = formatDropdownOptionsVendor(data?.data, 'vendorName', 'id', 'vendorCode') || [];
    const rawById = new Map((data?.data || []).map((v) => [v?.id, v]));
    const vendorOptions = options.map((opt) => {
      const raw = rawById.get(opt?.id) || {};
      const vendorName = raw?.vendorName || opt?.vendorName || opt?.label || '';
      const vendorCode = raw?.vendorCode || opt?.vendorCode || '';
      const sapVendorCode = raw?.sapVendorCode;
      return {
        ...opt,
        label: buildVendorDropdownLabel(vendorCode, vendorName, sapVendorCode),
        searchLabel: buildVendorSearchLabel(vendorCode, vendorName, sapVendorCode),
        sapVendorCode: sapVendorCode ?? opt?.sapVendorCode
      };
    });
    setfilteredVendorList(vendorOptions);
  }
  const {
    mutate: getvendorCategoryData
  } = useMutation(['getVendorCategory'], getVendorQuery, {
    onSuccess: filterCategoryvendor
  });
  const filterExpensiveVendor = (data) => {
    setexpenseitemsData(formatDropdownOptions(data?.data, 'expenseLineItem', 'expenseLineItemID'))
  }
  const {
    mutate: getvendorExpensiveData
  } = useMutation(['getVendorExpenseitem'], getVendorExpenseQuery, {
    onSuccess: filterExpensiveVendor
  });

  const queryClient = useQueryClient();
  const extractPoId = (payload) => {
    if (!payload) return null;
    return payload?.id
      || payload?.poId
      || payload?.purchaseOrderId
      || payload?.data?.id
      || payload?.data?.poId
      || payload?.data?.purchaseOrderId
      || payload?.response?.[0]?.id
      || payload?.data?.response?.[0]?.id
      || null;
  };
  const {
    mutate: sendPOEditData,
    isLoading: sendPOEditLoading,
  } = useMutation(['sendPO'], sendPOQuery, {
    onSuccess: (response) => {
      queryClient.invalidateQueries('getPOList');
      const returnedPoId = extractPoId(response) || poId;
      history.push(`/po/${returnedPoId}`);
      showAlert('Purchase Order sent successfully', 'success');
    },
    onError: () => {
      history.push(`/po/${poId}`);
    }
  });

  if (isAddError) {
    resetAdd();
    showAlert('Something went wrong', 'error');
  }
  if (issendPurchaseOrderError) {
    resetsendPurchaseOrder();
    history.push(`/`);
  }

  if (isEditError) {
    resetEdit();
    history.push('/');
    showAlert('Given Purchase order is not active', 'error');
  }
  if (isAddSuccess) {
    setformValues(null);
    resetAdd();

    if (isDraft) {
      showAlert('Purchase Order Saved as Draft Successfully', 'success');
    } else {
      showAlert('Purchase Order Created Successfully', 'success');
    }
    history.push('/');
  }
  if (issendPurchaseOrderSuccess) {
    setformValues(null);
    resetsendPurchaseOrder();
    refetchArq();
  }

  if (isEditSuccess) {
    setformValues(null);
    resetEdit();
    refetchArq();
    if (isDraft) {
      showAlert('Purchase Order Updated Successfully', 'success');
    history.push(`/po/${poId}`);
    }
  }

  useEffect(() => {
    let modified = false;
    if (dataObj?.poStatus === 'Draft') {
      dataObj?.purchaseOrderCrew.forEach((item) => {
        if (item?.ppeIsModified === true) {
          modified = true;
        }
      });
    }
    if (modified) {
      showAlert('PO details are updated as per the latest Master data change. Kindly review before sending the PO', 'warning');
    }
  }, [dataObj?.poStatus]);
  
  useEffect(() => {
    if (!getCompanyDataLoading) {
      setisLoading(false);
    }
  }, [getCompanyDataLoading]);
useEffect(() => {
  dataObj?.purchaseOrderCrew.map((crew) => {
    if (crew?.invoiceStatus?.toLowerCase().includes('payment') || crew?.invoiceStatus?.toLowerCase().includes('voucher') || crew?.invoiceStatus?.toLowerCase().includes('transferred')) {
      setdisableHeader(true);
    }
  })
}, [dataObj]);
const getAccountCode = (id, values) => {
  const crewItem = values?.purchaseOrderCrew?.[id];
  if (!crewItem) return null;

  const expenseLineItemID = crewItem?.expenseLineItemId;
  const matchedItem = expenseitemsData?.find(
    (item) => String(item?.expenseLineItemID ?? item?.value) === String(expenseLineItemID)
  );

  if (matchedItem?.companyExpenseAccountCodeList?.length > 0) {
    const companyMatch = matchedItem.companyExpenseAccountCodeList.find(
      (entry) => String(entry.companyId) === String(companyId)
    );
    if (companyMatch?.accountCodeName) {
      return companyMatch.accountCodeName;
    }
  }

  // Always prefer current selection derived code; saved value is only a last fallback.
  return (
    matchedItem?.accountCode
    || crewItem?.accountCode
    || savedaccountCode?.[id]?.accountCode
    || null
  );
};
  const NULL_GUID = '00000000-0000-0000-0000-000000000000';
  const isCrewIdEmpty = (id) =>
    id == null || id === '' || String(id || '').toLowerCase() === NULL_GUID.toLowerCase();
  const isVesselRevisionIdEmpty = (id) =>
    id == null || id === '' || String(id || '').toLowerCase() === NULL_GUID.toLowerCase();
  const normalizeVesselRevisionId = (id) => (isVesselRevisionIdEmpty(id) ? '' : id);
  const isPortIdEmpty = (id) =>
    id == null || id === '' || String(id || '').toLowerCase() === NULL_GUID.toLowerCase();
  const normalizePortId = (id) => (isPortIdEmpty(id) ? '' : id);

  const createReqFormat = (invalidCourceData) => {
    const req = { ...formValues };
    // Agency PO always sends pocategory as 2
    req.pocategory = 2;
    const expenseFields = expenseCategoryList.find((
      { expenseCategoryID }) => expenseCategoryID === formValues?.expenseCategoryId)?.expenseFields;
    if (expenseFields) {
      const categoryDetails = expenseFields
        .map((i) => {
          if (i.key in formValues) {
            return { ...i, value: formValues[i.key] };
          }
        })
        ?.filter((i) => i);

      if (categoryDetails.length > 0) {
        req['categoryDetails'] = categoryDetails;
      }
    }
    let formatedPurchaseOrderCrew = [];
    if (req?.purchaseOrderCrew?.length > 0) {
      formatedPurchaseOrderCrew = req.purchaseOrderCrew.map((element) => {
        const cleaned = removeEmpty(element);
        const defaultUuid = defaultCrewData?.uuid ?? defaultCrewUuidRef.current;
        if (isCrewIdEmpty(cleaned.crewId) && defaultUuid) {
          cleaned.crewId = defaultUuid;
        }
        return cleaned;
      });
    }
    req.purchaseOrderCrew = formatedPurchaseOrderCrew;

    const {
      vendorId,
      expenseCategoryId,
      currencyId,
      purchaseOrderCrew,
      isBulkOrder,
      address,
      logDescription,
      companyId,
      poNumber,
      description,
      level2Assignee,
   //   dateOfService,
      serviceCompletionDate: serviceCompletionDateRaw,
      purposeId,
      purposeLevelId,
      budgetCategory,
      pocategory,
      portId,
      isAdvancePO,
      poAttachmentIds,
      advancePurchaseOrder,
    } = req;
    const level2IdPrimitive = (val) => {
      if (val == null) return null;
      if (typeof val === 'string') return val;
      if (typeof val === 'number') return String(val);
      if (typeof val === 'object') return val.id ?? val.value ?? null;
      return null;
    };
    const level2AssigneeId = level2IdPrimitive(level2Assignee);
    const selectedLevel2Approver = (level2ApproverList || []).find(
      (a) => level2AssigneeId != null && String(level2IdPrimitive(a?.id)) === String(level2AssigneeId)
    );
    const level2ApproverId = selectedLevel2Approver ? level2IdPrimitive(selectedLevel2Approver.id) : null;
    const serviceCompletionDate = serviceCompletionDateRaw && (moment(serviceCompletionDateRaw).isValid())
      ? new Date(serviceCompletionDateRaw).toISOString()
      : serviceCompletionDateRaw;
    const defaultUuid = defaultCrewData?.uuid ?? defaultCrewUuidRef.current;
    const resolveCrewId = (crewIdVal) =>
      (isCrewIdEmpty(crewIdVal) && defaultUuid) ? defaultUuid : crewIdVal;

    const reqObj = {
      vendorId,
      poNumber,
      expenseCategoryId,
      currencyId,
      purchaseOrderCrew: purchaseOrderCrew?.map((
        {accountCode, categoryDetails, crewId, expenseLineItemId, ppeCategoryDetails, ppeDeliveryRemarks,
          plannedVesselId, amount, purchaseOrderCrewId, crewRank, airfareStatus, plannedVesselRevisionId }
          ) => ({
        crewId: resolveCrewId(crewId),
        accountCode,
        amount,
        expenseLineItemId,
        plannedVesselId: plannedVesselId || req.plannedVesselId,
        purchaseOrderCrewId,
        categoryDetails,
        ppeCategoryDetails,
        ppeDeliveryRemarks,
        plannedVesselRevisionId: normalizeVesselRevisionId(plannedVesselRevisionId || req.plannedVesselRevisionId),
        crewRank,
        airfareStatus: airfareStatus || airfareOpen
      })),
      isBulkOrder,
      address,
      logDescription,
      isSaveAsDraft: isDraft,
      companyId,
      description,
     // dateOfService,
      serviceCompletionDate,
      purposeId,
      purposeLevelId,
      budgetCategory,
      pocategory,
      portId: normalizePortId(portId),
      poAttachmentIds,
      isAdvancePO: !!isAdvancePO,
     ...(level2ApproverId && { level2Approver: level2ApproverId }),
      ...(isAdvancePO && {
        advancePurchaseOrder: (advancePurchaseOrder || []).map((item) => {
          const dateRaw = item?.proformaInvoiceDate;
          const proformaInvoiceDate = dateRaw && moment(dateRaw).isValid()
            ? new Date(dateRaw).toISOString()
            : dateRaw;
          const purchaseOrderIdForArq = poId || dataObj?.id;
          const isNullGuid = (val) =>
            val == null || val === '' || String(val || '').toLowerCase() === '00000000-0000-0000-0000-000000000000';
          const arqAttachments = (item?.arqAttachments || []).map((att) => ({
            ...att,
            purchaseOrderId: purchaseOrderIdForArq || (!isNullGuid(att.purchaseOrderId) && att.purchaseOrderId) || att.purchaseOrderId
          }));
          return {
            ...(item?.id && { id: item.id }),
            purchaseOrderId: purchaseOrderIdForArq,
            ...(item?.status !== undefined && { status: item.status }),
            paymentTermsId: item?.paymentTermsId,
            advanceAmount: item?.advanceAmount,
            proformaInvoiceNo: item?.proformaInvoiceNo,
            proformaInvoiceDate,
            arqAttachments,
            arqAttachmentIds: item?.arqAttachmentIds,
            remarks: item?.remarks,
          };
        }),
      }),
    };
    const duplicateCheck = (duplicate) => {
      if (duplicate?.data?.isDuplicateExists) {
        setduplicateData(duplicate.data.poInfo);
        setSaveModal(true);
      } else {
        setMailModal(true);
      }
      return () => clearTimeout(timer);
    };
    const handleSendPO = async () => {
      setMailVendorList(filteredVendorList);
      setisduplicateloading(true);
      await GetDuplicatePOEx(reqObj);
      setTimeout(() => duplicateCheck(JSON.parse(localStorage.getItem('duplicatecheck'))), 500);    
};

    if (reqObj?.purchaseOrderCrew?.length > 0) {
      setEditPoValues(reqObj);
      // check reqObj?.purchaseOrderCrew and find duplicate crewId and check its having the same expenseLineItemId
      const airfareId = expenseCategoryList?.find(({ label }) => label === 'Airfare')?.expenseCategoryID;
      const trainingId = expenseCategoryList?.find(({ label }) => label === 'Training')?.expenseCategoryID;	
      // check different crewId present in the purchaseOrderCrew	
      let invalidChecks = true;
      
    if (trainingId && formValues?.expenseCategoryId === trainingId && invalidCourceData?.data?.isMolTraining && invalidCourceData?.data?.validationResults.some(validationResult => validationResult?.isValid === false)) {
      {invalidCourceData?.data?.validationResults?.map((item) => {
        if (item?.isValid === false) {
        let tempData = item?.expenseLineItem;
        let stringData= 'There is no Course Code available for this Line Item- '
        showAlert(stringData+tempData, 'error');
        invalidChecks = false;
        }
      })}
    }
      const sameCrew = reqObj?.purchaseOrderCrew?.filter((item, index, self) => index === self.findIndex((t) => t.crewId === item.crewId));	
      let trainingAcceptable=true;	
     if (trainingId && reqObj?.expenseCategoryId === trainingId && sameCrew.length > 1 && !isBulkOrder) {	
        trainingAcceptable = false;	
      }

      if (trainingAcceptable && invalidChecks === true) {
    if (mode === 'add') {
      setDraft(true);
      if (!isDraft) {
        handleSendPO();
      } else {
        if (!issendPurchaseOrderError)
        {
        addPurchaseOrder(reqObj);
        }
      }
    } else {
     if (!isDraft) {
        reqObj['purchaseOrderCrew'] = purchaseOrderCrew.map(({accountCode, crewCode, firstName, lastName, categoryDetails, ppeCategoryDetails, ppeDeliveryRemarks, crewId, plannedVesselId, expenseLineItemId,airfareStatus, amount, purchaseOrderCrewId, id, plannedVesselRevisionId }) => ({
        crewId: resolveCrewId(crewId),
        crewCode,
        firstName,
        lastName,
        amount,
        expenseLineItemId,
        plannedVesselId: plannedVesselId || req.plannedVesselId,
        purchaseOrderCrewId,
        categoryDetails,
        ppeCategoryDetails,
        ppeDeliveryRemarks,
        id,
        accountCode,
        poAttachmentIds,
        airfareStatus: airfareStatus || airfareOpen,
        plannedVesselRevisionId: normalizeVesselRevisionId(plannedVesselRevisionId || req.plannedVesselRevisionId)
      }));
      editPurchaseOrder({ ...reqObj, id: dataObj?.id, poNumber: poNumber });
    //  setEditPoValues(reqObj);
      handleSendPO();
    } else {
      reqObj['purchaseOrderCrew'] = purchaseOrderCrew.map(({accountCode, crewCode, firstName, lastName, categoryDetails, ppeCategoryDetails, ppeDeliveryRemarks, crewId, plannedVesselId, expenseLineItemId,airfareStatus, amount, purchaseOrderCrewId, id,plannedVesselRevisionId }) => ({
        crewId: resolveCrewId(crewId),
        crewCode,
        firstName,
        lastName,
        amount,
        expenseLineItemId,
        plannedVesselId: plannedVesselId || req.plannedVesselId,
        purchaseOrderCrewId,
        categoryDetails,
        ppeCategoryDetails,
        ppeDeliveryRemarks,
        id,
        poAttachmentIds,
        accountCode,
        airfareStatus: airfareStatus || airfareOpen,
        plannedVesselRevisionId: normalizeVesselRevisionId(plannedVesselRevisionId || req.plannedVesselRevisionId)
      }));
      editPurchaseOrder({ ...reqObj, id: dataObj?.id, poNumber: poNumber });
  }
}
 
  } else {	
    if (invalidChecks === true) {
    showAlert('Different Crew Codes are not allowed for Expense Category- Training.', 'error');	
    }
  }
  } else {
    showAlert('Please add atleast one crew', 'error');
  }
  };
  const openDuplicate = (id) => {
    window.open(`/po/${id}`);
  };
  const handleDiscard = () => {
    setisduplicateloading(false);
    history.push('/');
  }
  const handleSave = () => {
    setSaveModal(false);
    setMailModal(true);
  };
  const handleDraft = (values) => () => {
    const raw = values ?? editPoValues ?? formValues ?? {};
    const req = prepareReqFromValues(raw);
    const payload = buildPurchaseOrderPayload(req, true);
    if (mode === 'edit') {
      editPurchaseOrder({ ...payload, id: dataObj?.id, poNumber: payload?.poNumber ?? dataObj?.poNumber });
      showAlert('Purchase Order Updated Successfully', 'success');
      history.push(`/po/${poId}`);
      setSaveModal(false);
    } else {
      setSaveModal(false);
      addPurchaseOrder(payload);
    }
  };

  const handleMail = () => {
    setisduplicateloading(false);
    if (mailBasicInfo?.to?.length > 0 && mailBasicInfo?.subject?.length > 0) {
        if (mode === 'add') {
      const payload = editPoValues || formValues;
      const withMailValuesAdd = { ...payload, mailBasicInfo: [mailBasicInfo] };
      sendPurchaseOrder(withMailValuesAdd, {
        onSuccess: (response) => {
          const returnedPoId = extractPoId(response) || poId;
          showAlert('Purchase Order Sent Successfully', 'success');
          history.push(`/po/${returnedPoId}`);
        }
      });
        } else {
         const withMailValuesEdit = {poId, mailBasicInfo : [mailBasicInfo]};
        sendPOEditData(withMailValuesEdit);
        }
      // }
    setMailModal(false);
    } else {
      if (mailBasicInfo?.to?.length === 0){
      showAlert('Please fill the To field', 'error');
      }else if(mailBasicInfo?.subject?.length === 0){
      showAlert('Please fill the Subject field', 'error');
      }
    }
  };
  const cancelMail = () => {
    const raw = editPoValues || formValues;
    const payload = editPoValues || buildPurchaseOrderPayload(prepareReqFromValues(raw || {}), false);
    if (mode === 'edit') {
      const draftPayload = { ...payload, id: dataObj?.id, poNumber: payload?.poNumber ?? dataObj?.poNumber, isSaveAsDraft: true };
      editPurchaseOrder(draftPayload);
      showAlert('Purchase Order Saved as Draft', 'success');
      history.push(`/po/${poId}`);
      setMailModal(false);
    } else {
      setMailModal(false);
      const addPayload = { ...payload, isSaveAsDraft: true };
      addPurchaseOrder(addPayload);
    }
  };

  if (
    isAddLoading
    || sendPOEditLoading
    || issendPurchaseOrderLoading
    || isEditLoading
    || expenseCategoryLoading
    || isFetchingPo
    || purposeLevelOneLoading
  ) {
    return <Loader message="Loading" />;
  }
  return (
    <>
      <div className="pb-28.5">
        <Formik
           initialValues={{
            // Header fields
            expenseCategoryId: dataObj?.expenseCategoryId ?? '',
            vendorId: dataObj?.vendorId ?? '',
            companyId: dataObj?.companyId ?? null,
            currencyId: dataObj?.currencyId ?? 1,
            budgetCategory: dataObj?.budgetCategory ?? '',
            purposeId: dataObj?.purposeId ?? '',
            purposeLevelId: dataObj?.purposeLevelId ?? '',
            portId: dataObj?.portId ?? '',
            plannedVesselId: dataObj?.plannedVesselId ?? '',
            plannedVesselRevisionId: dataObj?.plannedVesselRevisionId ?? '',
            description: dataObj?.description ?? '',
            serviceCompletionDate: dataObj?.serviceCompletionDate ?? '',
            vesselName: dataObj?.vesselName ?? '',
            vesselCode: dataObj?.vesselCode ?? '',
            imo: dataObj?.imo ?? '',
            sapVesselCompanyCode: dataObj?.sapVesselCompanyCode ?? '',
            // Crew & line items
            purchaseOrderCrew: dataObj?.purchaseOrderCrew ?? [{
              crewId: '',
              expenseLineItemId: '',
              plannedVesselId: '',
              amount: '',
              crewCode: '',
              categoryDetails: '',
              ppeCategoryDetails: [],
              ppeDeliveryRemarks: '',
              plannedVesselRevisionId: ''
            }],
            // Attachments & advance
            attachments: dataObj?.attachments ?? [],
            poAttachmentIds: dataObj?.poAttachmentIds ?? [],
            isAdvancePO: dataObj?.isAdvancePO ?? false,
            advancePurchaseOrder: dataObj?.advancePurchaseOrder ?? [],
            // Legacy fields
            poNumber: dataObj?.poNumber ?? '',
            poStatus: dataObj?.poStatus ?? '',
            dueDate: dataObj?.dueDate ?? null,
            approvalLogs: dataObj?.approvalLogs ?? [],
            ...dataObj,
            level2Approver: dataObj?.level2Approver ?? null,
            level2Assignee: (() => {
              const fromApprover = level2IdFromApprover(dataObj?.level2Approver);
              const fromAssignee = level2IdFromApprover(dataObj?.level2Assignee);
              const fromId = dataObj?.level2ApproverId != null ? String(dataObj.level2ApproverId) : '';
              const raw = fromApprover || fromAssignee || fromId || (dataObj?.level2Assignee != null ? dataObj.level2Assignee : '');
              const id = typeof raw === 'string' ? raw : (typeof raw === 'number' ? String(raw) : '');
              return level2IdNormalize(id) || id || '';
            })()
          }}
          enableReinitialize
          validationSchema={validationSchema}
          validate={(values) => {
            const trainingId = expenseCategoryList?.find(({ label }) => label === 'Training')?.expenseCategoryID;
            let error = {};
            const companySelected = companyList.find(obj => obj.id === values?.companyId);
            if (trainingId &&values?.expenseCategoryId === trainingId && !companySelected?.groupCompanyCode) {
              error.companyId = 'Please select company with shipnet code';
            }
            if (values?.companyId && !companySelected?.sapCompanyCode) {
              error.companyId = 'Please select company with SAP Company Code';
            }
           const vendorSelected = filteredVendorList?.find((v) => v.id === values?.vendorId);
           if (values?.vendorId && vendorSelected?.sapVendorCode === null) {
             error.vendorId = 'Please select vendor with SAP Vendor Code';
           }
            const vesselRevisionId = values?.plannedVesselRevisionId;
            const vesselSelected = resolveAgencyHeaderVessel(
              values,
              vesselListForSelect,
              dataObj,
              poVesselFromDataObj
            );
            const originalCrew = dataObj?.purchaseOrderCrew?.[0];
            const vesselUnchanged = mode === 'edit' && (
              eqGuid(dataObj?.plannedVesselRevisionId, vesselRevisionId)
              || eqGuid(originalCrew?.plannedVesselRevisionId, vesselRevisionId)
              || (
                eqGuid(dataObj?.plannedVesselId, values?.plannedVesselId)
                && String(dataObj?.vesselCode || '').trim().toUpperCase()
                  === String(values?.vesselCode || '').trim().toUpperCase()
              )
            );
            const sapVesselCode = String(
              values?.sapVesselCompanyCode
              || vesselSelected?.sapVesselCompanyCode
              || dataObj?.sapVesselCompanyCode
              || ''
            ).trim();
            if (
              !vesselUnchanged
              && (vesselRevisionId || values?.plannedVesselId)
              && vesselSelected
              && !sapVesselCode
            ) {
              error.purchaseOrderCrew = 'Please select vessel with SAP Vessel Code';
            }
            
            // Get vendor code and category for Rank validation (only for Training category with specific vendors)
            const selectedVendorForValidation = filteredVendorList?.find(({ id, value }) => id === values?.vendorId || value === values?.vendorId);
            const vendorCodeForValidation = selectedVendorForValidation?.vendorCode?.toUpperCase() || '';
            const trainingCategoryId = expenseCategoryList?.find(({ label }) => label === 'Training')?.expenseCategoryID;
            const isTrainingCategory = trainingCategoryId ? values?.expenseCategoryId === trainingCategoryId : false;
            const isRankMandatoryVendor = vendorCodeForValidation.includes('MSSG') || vendorCodeForValidation.includes('SEALEARNINGSG');
            const isRankMandatory = isTrainingCategory && isRankMandatoryVendor;
            
            // values?.purchaseOrderCrew?.map((crewMember, crewIndex) => {

          

            //   if(isCrewPage){
            //     if (values?.purchaseOrderCrew[crewIndex].crewCode) {
            //       const missingDateOfBirth = !crewMember?.dateOfBirth;
            //       const missingRank = !crewMember?.rankName && !crewMember?.rankId;
                 // Mandatory: Vessel
            if (!values?.plannedVesselId && !values?.plannedVesselRevisionId) {
              error.plannedVesselRevisionId = 'Please select the Vessel';
            }  
          
            // Advance Request: total advance amount must be <= sum of PO line item amounts
            if (values?.isAdvancePO && Array.isArray(values?.advancePurchaseOrder) && values.advancePurchaseOrder.length > 0) {
              const roundMoney = (n) => Math.round((Number(n) + Number.EPSILON) * 100) / 100;
              const sumNumeric = (arr, key) => roundMoney((arr || []).reduce((acc, item) => {
                const n = Number(item?.[key]);
                return acc + (Number.isFinite(n) ? n : 0);
              }, 0));
              const norm = (s) => (s == null ? '' : String(s).trim().toLowerCase());
              const poTotalAmount = sumNumeric(values.purchaseOrderCrew, 'amount');
              const activeAdvanceRows = values.advancePurchaseOrder.filter(
                (item) => norm(item?.status) !== 'cancelled'
              );
              const advanceTotalAmount = sumNumeric(activeAdvanceRows, 'advanceAmount');
              if (Number.isFinite(poTotalAmount) && advanceTotalAmount > poTotalAmount) {
                error.advancePurchaseOrder = `Total advance amount (${advanceTotalAmount.toFixed(2)}) cannot exceed PO amount (${poTotalAmount.toFixed(2)}).`;
              } else {
                // Mandatory per ARQ row: Payment Terms, Advance Amount, Proforma Invoice No. (skip locked rows)
                const arqLockedStatuses = ['created', 'paid', 'cancelled'];
                const isLocked = (item) => {
                  const st = norm(item?.status);
                  return st !== '' && arqLockedStatuses.includes(st);
                };
                const rowErrors = [];
                let hasRowError = false;
                values.advancePurchaseOrder.forEach((item, i) => {
                  const err = {};
                  if (isLocked(item)) {
                    rowErrors.push(err);
                    return;
                  }
                  if (!item?.paymentTermsId || String(item.paymentTermsId).trim() === '') {
                    err.paymentTermsId = 'Please select Payment Terms';
                    hasRowError = true;
                  }
                  const amt = Number(item?.advanceAmount);
                  if (amt === undefined || amt === null || Number.isNaN(amt) || amt <= 0) {
                    err.advanceAmount = 'Please enter Advance Amount (greater than 0)';
                    hasRowError = true;
                  }
                  if (!item?.proformaInvoiceNo || String(item.proformaInvoiceNo).trim() === '') {
                    err.proformaInvoiceNo = 'Please enter Proforma Invoice No.';
                    hasRowError = true;
                  }
                  // Use arqAttachments only (form state): delete only updates arqAttachments, not arqAttachmentIds
                  const hasArqAttachments = Array.isArray(item?.arqAttachments) && item.arqAttachments.length > 0;
                  if (!hasArqAttachments) {
                    err.arqAttachments = 'Please add at least one ARQ Attachment';
                    hasRowError = true;
                  }
                  rowErrors.push(err);
                });
                if (hasRowError) error.advancePurchaseOrder = rowErrors;
              }
            }
          
            return error;
          }}
          
          onSubmit={(values) => {
            const updatedCrew = values.purchaseOrderCrew.map((crew, index) => {
              const code = getAccountCode(index, values);
              return {
                ...crew,
                accountCode: code || '',
                plannedVesselRevisionId: crew.plannedVesselRevisionId || values.plannedVesselRevisionId || ''
              };
            });
            // Agency PO always sends pocategory as 2
            values.pocategory = 2;
            const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
            const isServerId = (id) => typeof id === 'string' && uuidRegex.test(id);
            const getId = (a) => a?.attachmentId ?? a?.id ?? a?.docId ?? a?.poAttachmentId;
            const idsFromAttachments = (values?.attachments || [])
              .map(getId)
              .filter(Boolean)
              .filter(isServerId);
            const existingIds = Array.isArray(values?.poAttachmentIds) ? values.poAttachmentIds.filter(isServerId) : [];
            const poAttachmentIdsFromForm = [...new Set([...idsFromAttachments, ...existingIds])];
            const finalValues = {
              ...values,
              purchaseOrderCrew: updatedCrew,
              poAttachmentIds: poAttachmentIdsFromForm,
            };

            if (values?.purchaseOrderCrew?.length > 1) {
              const accountCodes = updatedCrew?.map((crew) => crew?.accountCode)?.filter(Boolean) || [];
              const budgetCheckPayload = {
                companyId: values?.companyId,
                vesselDetailsId: updatedCrew?.[0]?.plannedVesselRevisionId || '',
                poId: dataObj?.id || '',
                accountCode: accountCodes,
                poCategory: 2
              };

              checkBudgetType(budgetCheckPayload, {
                onSuccess: (response) => {
                  const { poBudgetType, accountCodes } = response?.data || {};
                  if (poBudgetType === 'Ok') {
                    setformValues(values?.purchaseOrderCrew?.length > 1 && mode === 'add'
                      ? { ...finalValues, isBulkOrder: false }
                      : finalValues);
                  } else {
                    const accountCodesList = accountCodes?.join(', ') || '';
                    let errorMessage = '';
                    
                    if (mode === 'edit') {
                      if (poBudgetType === 'Fixed') {
                        errorMessage = `The PO is Fixed Budget PO, but the following account codes are of Actual Budget Types. Account Codes: ${accountCodesList}`;
                      } else if (poBudgetType === 'Actual') {
                        errorMessage = `The PO is Actual Budget PO, but the following account codes are of Fixed Budget Types. Account Codes: ${accountCodesList}`;
                      }
                    } else {
                      if (poBudgetType === 'Fixed') {
                        errorMessage = `The first line-item has Fixed Budget account code. But the following account codes are of Actual Budget Types. Account Codes: ${accountCodesList}`;
                      } else if (poBudgetType === 'Actual') {
                        errorMessage = `The first line-item has Actual Budget account code. But the following account codes are of Fixed Budget Types. Account Codes: ${accountCodesList}`;
                      }
                    }
                    
                    showAlert(errorMessage, 'error');
                  }
                },
                onError: (error) => {
                  showAlert('Failed to validate PO budget type', 'error');
                  console.error('Budget Type Check Error:', error);
                }
              });
            } else {
              setformValues(values?.purchaseOrderCrew?.length > 1 && mode === 'add'
                ? { ...finalValues, isBulkOrder: false }
                : finalValues);
            }
          }}
        >
          {({ values, errors, touched, setFieldValue, submitCount, validateForm }) => {
            const prevSubmitCountRef = React.useRef(submitCount);
            const sapPoNumberPosition = values?.sapPoNumberPosition
              || dataObj?.sapPoNumberPosition
              || dataObj?.sapPoNumberPositionValue
              || '-';
            const normalizedSapPoNumberPosition = String(sapPoNumberPosition).toLowerCase().replace(/[^a-z]/g, '');
            const showHeaderSapPoNumber = normalizedSapPoNumberPosition.includes('header');
            const selectedVessel = resolveAgencyHeaderVessel(
              values,
              vesselListForSelect,
              dataObj,
              poVesselFromDataObj
            );
            useEffect(() => {
              if (mode !== 'edit' || editVesselSyncedRef.current || typeof setFieldValue !== 'function') return;
              const firstCrew = dataObj?.purchaseOrderCrew?.[0];
              const rev = dataObj?.plannedVesselRevisionId ?? firstCrew?.plannedVesselRevisionId ?? '';
              const id = dataObj?.plannedVesselId ?? firstCrew?.plannedVesselId ?? '';
              if (!rev && !id) return;
              setFieldValue('plannedVesselRevisionId', rev);
              setFieldValue('plannedVesselId', id);
              setFieldValue('vesselName', dataObj?.vesselName ?? firstCrew?.vesselName ?? '');
              setFieldValue('vesselCode', dataObj?.vesselCode ?? firstCrew?.vesselCode ?? '');
              setFieldValue('imo', dataObj?.imo ?? firstCrew?.imo ?? '');
              setFieldValue(
                'sapVesselCompanyCode',
                dataObj?.sapVesselCompanyCode ?? firstCrew?.sapVesselCompanyCode ?? ''
              );
              editVesselSyncedRef.current = true;
            }, [mode, dataObj, setFieldValue]);
            useEffect(() => {
              if (typeof setFieldValue !== 'function') return;
              const fromVessel = selectedVessel?.sapVesselCompanyCode;
              if (!fromVessel) return;
              if (String(values?.sapVesselCompanyCode || '').trim() === String(fromVessel).trim()) return;
              if (mode === 'edit' && String(dataObj?.sapVesselCompanyCode || '').trim()) return;
              setFieldValue('sapVesselCompanyCode', fromVessel);
            }, [
              selectedVessel?.sapVesselCompanyCode,
              values?.plannedVesselRevisionId,
              values?.plannedVesselId,
              values?.sapVesselCompanyCode,
              mode,
              dataObj?.sapVesselCompanyCode,
              setFieldValue
            ]);
            useEffect(() => {
              const err = errors.purchaseOrderCrew;
              if (submitCount > prevSubmitCountRef.current && typeof err === 'string' && err) {
                showAlert(err, 'error');
              }
              prevSubmitCountRef.current = submitCount;
            }, [errors.purchaseOrderCrew, submitCount]);


            useEffect(() => {
              if (mode === 'edit') return;
              if (company?.data?.result) {
                const { id } = company?.data?.result || {};
                setFieldValue('companyId', id);
              }
            }, [company, mode]);
             useEffect(() => {
                if (values?.description) {
                 setFieldValue('description', values?.description);
                 } 
            }, [values?.description]);

            useEffect(() => {
              if (typeof setFieldValue !== 'function') return;
              if (mode === 'edit' && poId) {
                const hasArqFromApi = arqListFromApi?.length > 0;
                const hasDataObjAdvance = dataObj?.advancePurchaseOrder && dataObj.advancePurchaseOrder.length > 0;
                if (hasArqFromApi) {
                  setFieldValue('advancePurchaseOrder', mapArqFromApi(arqListFromApi));
                  setFieldValue('isAdvancePO', true);
                  return;
                }
                if (hasDataObjAdvance) {
                  setFieldValue('advancePurchaseOrder', mapArqFromApi(dataObj.advancePurchaseOrder));
                  setFieldValue('isAdvancePO', true);
                  return;
                }
              }
              if (!poId || arqQueryResponse == null) return;
              const raw = arqQueryResponse?.data;
              const list = Array.isArray(raw)
                ? raw
                : (Array.isArray(arqQueryResponse) ? arqQueryResponse : (raw?.data ?? raw?.result ?? []));
              const normalized = Array.isArray(list) ? mapArqFromApi(list) : [];
              setFieldValue('advancePurchaseOrder', normalized);
              setFieldValue('isAdvancePO', normalized.length > 0);
            }, [poId, mode, arqQueryResponse, setFieldValue, dataObj?.advancePurchaseOrder, arqListFromApi]);

            useEffect(() => {
              if (values?.logDescription) {
            setFieldValue('logDescription', values?.logDescription);
              } 
            }, [values?.logDescription]);

            // Sync Level 2 Approver on edit when PO data loads (so dropdown shows selected approver)
            useEffect(() => {
              if (mode !== 'edit' || typeof setFieldValue !== 'function') return;
              const fromObj = level2IdFromApprover(dataObj?.level2Approver);
              const fromId = dataObj?.level2ApproverId != null ? String(dataObj.level2ApproverId) : '';
              const raw = fromObj || fromId;
              const id = raw ? (level2IdNormalize(raw) || raw) : '';
              if (id) setFieldValue('level2Assignee', id);
            }, [mode, dataObj?.level2Approver?.id, dataObj?.level2Approver?.name, dataObj?.level2ApproverId, setFieldValue, level2ApproverOptions?.length]);

            // Reload behavior: when user changes company or category, reset Advance toggle to OFF and Level 2 approver (skip on edit initial load)
            const prevCompanyCategoryRef = React.useRef({ companyId: dataObj?.companyId, expenseCategoryId: dataObj?.expenseCategoryId });
            useEffect(() => {
              const prev = prevCompanyCategoryRef.current;
              const currentCompany = values?.companyId;
              const currentCategory = values?.expenseCategoryId;
              const isInitialEditLoad = mode === 'edit' && prev.companyId == null && prev.expenseCategoryId == null && (currentCompany != null || currentCategory != null);
              if (isInitialEditLoad) {
                prevCompanyCategoryRef.current = { companyId: currentCompany, expenseCategoryId: currentCategory };
                return;
              }
              if (prev.companyId !== currentCompany || prev.expenseCategoryId !== currentCategory) {
                setFieldValue('isAdvancePO', false);
                setFieldValue('level2Assignee', '');
                if (prev.companyId !== currentCompany) {
                  setFieldValue('plannedVesselId', '');
                  setFieldValue('plannedVesselRevisionId', '');
                  setFieldValue('vesselName', '');
                  setFieldValue('vesselCode', '');
                  setFieldValue('imo', '');
                  (values?.purchaseOrderCrew ?? []).forEach((_, i) => {
                    setFieldValue(`purchaseOrderCrew[${i}].plannedVesselId`, '');
                    setFieldValue(`purchaseOrderCrew[${i}].plannedVesselRevisionId`, '');
                  });
                }
                prevCompanyCategoryRef.current = { companyId: currentCompany, expenseCategoryId: currentCategory };
              }
            }, [mode, values?.companyId, values?.expenseCategoryId, setFieldValue]);

            useEffect(() => {
              const ppe = expenseCategoryList?.find(({ label }) => label === 'PPE' || label === 'Vessel PPE')?.expenseCategoryID;
              if (ppe && values?.expenseCategoryId === ppe) {
                const temp=orderBy(formatDropdownOptions(currencies?.data, 'code', 'id'), 'code')
                setCurrencyList(temp?.filter((item) => item?.label === 'INR' || item?.label === 'USD'));
              } else {
                setCurrencyList(orderBy(formatDropdownOptions(currencies?.data, 'code', 'id'), 'code'));
              }
            }, [values?.expenseCategoryId]);
            const resetCategoryRelatedFields = () => {
              setFieldValue('companyId', null);
              setFieldValue('vendorId', '');
              setFieldValue('expenseLineItemId', '');
              setFieldValue('budgetCategory', '');
              setFieldValue('currencyId', 1 );
              setFieldValue('description', '');
              setFieldValue('logDescription', '');
              setFieldValue('purposeId', '');
              setFieldValue('purposeLevelId', '');
              setFieldValue('plannedVesselId', '');
              setFieldValue('plannedVesselRevisionId', '');
              setFieldValue('vesselName', '');
              setFieldValue('vesselCode', '');
              setFieldValue('imo', '');
              setAddress('');
              setexpenseitemsData([]);
              setfilteredVendorList([]);
            };

            useEffect(() => {
              if (values?.purposeId) {
                getLevelTwoPurposeData(values?.purposeId);
              }
            }, [values?.purposeId]);

            useEffect(() => {
              const decodedToken = jwt_decode(localStorage.getItem('access_token'));
              setmailBasicInfo({ ...mailBasicInfo, cc: [decodedToken?.email] });
            }, []);
            useEffect(() => {
              if (values?.vendorId) {
                const vendor = filteredVendorList?.find(({ id }) => id === values?.vendorId);
                if (vendor === undefined) {
                const vendorAdd = { id: values?.vendorId,
                  value: values?.vendorId,
                  vendorName: values?.vendorsName,
                  label: buildVendorDropdownLabel(
                    values?.vendorCode,
                    values?.vendorsName,
                    values?.sapVendorCode
                  ),
                  searchLabel: buildVendorSearchLabel(
                    values?.vendorCode,
                    values?.vendorsName,
                    values?.sapVendorCode
                  ),
                  vendorCode: values?.vendorCode,
                  sapVendorCode: values?.sapVendorCode,
                  address: values?.address
                };
                // adding vendorAdd object to filteredVendorList
                const newVendorList = [...filteredVendorList, vendorAdd];
                setfilteredVendorList(newVendorList);
              }
                const address = vendor?.vendorAddress
                if (address === null) {
                setAddress('');
                } else {
                  setAddress(address);
              }
            }
            }, [values?.vendorId, dataObj, filteredVendorList, values?.purchaseOrderCrew]);
            useEffect(() => {
              if (values?.vendorId) {
                getvendorExpensiveData(values);
              }
              if (oldVendorId !== values?.vendorId) {
                  setFieldValue('companyId', null);
                  setFieldValue('expenseLineItemId', '');
                  setFieldValue('budgetCategory', '');
                  setFieldValue('currencyId', 1);
                  setFieldValue('description', '');
                  setFieldValue('logDescription', '');
                  setFieldValue('purposeId', '');
                  setFieldValue('purposeLevelId', '');
                  setFieldValue('purchaseOrderCrew', [{
                    crewId: '',
                    expenseLineItemId: '',
                    plannedVesselId: '',
                    amount: '',
                    crewCode: '',
                    categoryDetails: '',
                    ppeCategoryDetails: '',
                    ppeDeliveryRemarks: ''
                  }]);
              }
            }, [values?.vendorId]);
            useEffect(() => {
              if (values?.companyId) {
                      getVesselData(values?.companyId);
              }
            }, [values?.companyId]);

            useEffect(() => {
              const plannedVesselRevisionId = values?.plannedVesselRevisionId
                ?? values?.purchaseOrderCrew?.[0]?.plannedVesselRevisionId;
              setLevel2ApproverParams({
                companyId: values?.companyId,
                expenseCategoryId: values?.expenseCategoryId,
                plannedVesselRevisionId: plannedVesselRevisionId != null && plannedVesselRevisionId !== ''
                  ? plannedVesselRevisionId
                  : undefined
              });
            }, [
              values?.companyId,
              values?.expenseCategoryId,
              values?.plannedVesselRevisionId,
              values?.purchaseOrderCrew
            ]);

            useEffect(async () => {
              if (formValues) {
                let invalidCourceData;
                // check formvalues?.expenseCategoryId is Training expense categoryId
                const trainingId = expenseCategoryList?.find(({ label }) => label === 'Training')?.expenseCategoryID;
                if (trainingId && formValues?.expenseCategoryId === trainingId) {
                const expenseLineItemId = formValues?.purchaseOrderCrew?.map((crew) => crew?.expenseLineItemId) ?? [];
                const payload = {
                    expenseCategoryId: formValues.expenseCategoryId,
                    vendorId: formValues.vendorId,
                    expenseLineItemId
                };                
                invalidCourceData = await axios.post(apiurl?.validateCourseCode, payload);
              }
                if (
                  (isDraft || mode === 'edit') ||
                  (formValues && 'isBulkOrder' in formValues) ||
                  formValues?.purchaseOrderCrew?.length < 2
                ) {
                  if (duplicate?.data.isDuplicateExists) {
                    setduplicateData(duplicate.data.poInfo);
                    setSaveModal(true);
                    } else {
                    createReqFormat(invalidCourceData);
                  }
                }
              }
            }, [formValues]);
            useEffect(() => {
              if (values?.expenseCategoryId) {
                setCompanyId('')
                const fetchData = async () => {
                  getCompanyByCategory();
                //  const companyIdForCrew = mode === 'edit' ? (values?.companyId ?? 0) : (values?.companyId ?? 0);
                  if (mode === 'add') {
                    try {
                      const crewData = await getDefaultCrew(0);
                      const raw = crewData?.data;
                      if (raw) {
                        if (raw?.uuid) defaultCrewUuidRef.current = raw.uuid;
                        setDefaultCrewData(raw);
                        setSelectedDefaultCrewData(raw);
                        const uuid = raw?.uuid;
                        const crewCode = raw?.crewCode;
                        if (uuid && values?.purchaseOrderCrew?.length > 0) {
                          setFieldValue('purchaseOrderCrew[0].crewId', uuid);
                          if (crewCode != null) setFieldValue('purchaseOrderCrew[0].crewCode', crewCode);
                        }
                      }
                    } catch (error) {
                      console.error('Error fetching crew data:', error);
                    }
                  } else if (mode === 'edit') {
                    setCompanyId(values.companyId);
                    const crewData = await getDefaultCrew(0);
                    const raw = crewData?.data;
                    if (raw) {
                      if (raw?.uuid) defaultCrewUuidRef.current = raw.uuid;
                      setDefaultCrewData(raw);
                      setSelectedDefaultCrewData(raw);
                      setSavedAccountCode(dataObj?.purchaseOrderCrew);
                      const uuid = raw?.uuid;
                      const crewCode = raw?.crewCode;
                      const currentCrewId = values?.purchaseOrderCrew?.[0]?.crewId;
                      const isEmpty = isCrewIdEmpty(currentCrewId);
                      if (uuid && values?.purchaseOrderCrew?.length > 0 && isEmpty) {
                        setFieldValue('purchaseOrderCrew[0].crewId', uuid);
                        if (crewCode != null) setFieldValue('purchaseOrderCrew[0].crewCode', crewCode);
                      }
                    }
                  }
                };
                fetchData()
              }
              
              const airfareId = expenseCategoryList?.find(({ label }) => label === 'Airfare')?.expenseCategoryID;
              if (values?.expenseCategoryId === airfareId) {
                  setairfareOpen(0);
              } else {
                setairfareOpen(null);
              }
              if (values?.expenseCategoryId) {
                if (!initialDataLoaded) {
                  resetCategoryRelatedFields();
                }
                const expenseItems = expenseItemList?.filter(({ expenseCategoryID }) => expenseCategoryID === values?.expenseCategoryId);
                getvendorCategoryData(values?.expenseCategoryId);
                if (OldExpenseCategoryId === values?.expenseCategoryId) {
                  if (filterAndFillExpItm(expenseItems)) {
                    setexpenseitemsData((prev) => {
                      const crewRef = Array.isArray(dataObj?.purchaseOrderCrew) ? dataObj?.purchaseOrderCrew?.[0] : dataObj?.purchaseOrderCrew;
                      return [{ ...dataObj, label: crewRef?.expenseLineItem, value: crewRef?.expenseLineItemId }, ...prev];
                    });
                  }
                }
                setinitialDataLoaded(true);
                if (OldExpenseCategoryId !== values?.expenseCategoryId) {
                  resetCategoryRelatedFields();
                //  setFieldValue('dateOfService', []);
                  setFieldValue('purchaseOrderCrew', [{
                    crewId: defaultCrewData?.uuid ?? '',
                    crewCode: defaultCrewData?.crewCode ?? '',
                    expenseLineItemId: '',
                    plannedVesselId: '',
                    amount: '',
                    categoryDetails: '',
                    ppeCategoryDetails: '',
                    ppeDeliveryRemarks: '',
                    plannedVesselRevisionId: ''
                  }]);
                }
              }
            }, [values?.expenseCategoryId]);

            useEffect(() => {
              if (values?.CheckIn) {
                if (!checkOutDataLoaded) {
                  setFieldValue('CheckOut', '');
                }
                setcheckOutDataLoaded(false);
              }
            }, [values?.CheckIn]);

           const OnchangedCompanyValue = async(id, values) => {
            try {
              setCompanyId(id);
              setFieldValue('plannedVesselId', '');
              setFieldValue('plannedVesselRevisionId', '');
              setFieldValue('vesselName', '');
              setFieldValue('vesselCode', '');
              setFieldValue('imo', '');
              if (values?.purchaseOrderCrew) {
                values.purchaseOrderCrew.forEach((element, index) => {
                  setFieldValue(`purchaseOrderCrew[${index}].age`, null);
                  setFieldValue(`purchaseOrderCrew[${index}].firstName`, null);
                  setFieldValue(`purchaseOrderCrew[${index}].lastName`, null);
                  setFieldValue(`purchaseOrderCrew[${index}].gender`, null);
                  setFieldValue(`purchaseOrderCrew[${index}].dateOfBirth`, null);
                  setFieldValue(`purchaseOrderCrew[${index}].rankName`, null);
                  setFieldValue(`purchaseOrderCrew[${index}].crewCode`, null);
                  setFieldValue(`purchaseOrderCrew[${index}].crewId`, null);
                  setFieldValue(`purchaseOrderCrew[${index}].plannedVesselId`, '');
                  setFieldValue(`purchaseOrderCrew[${index}].plannedVesselRevisionId`, '');
                });
              }
              setFieldValue('purchaseOrderCrew[0].ppeCategoryDetails', []);
              setFieldValue('purchaseOrderCrew[0].amount', '');
              setFieldValue('purchaseOrderCrew[0].plannedVesselId', '');
              setFieldValue('purchaseOrderCrew[0].plannedVesselRevisionId', '');
            } catch (error) {
              console.error('Error fetching crew data:', error);
            }
            }
            return (
              <>
              <Form className="grow" id="my-form" >
                {values?.poNumber ? (
                  <div className=" text-base mb-4 mt-6">
                    {values?.poNumber}
                    <span className="pl-2">
                    {values?.poStatus && <Chip style={{backgroundColor: values?.dueDate >= 180 ? '#f68681' : '#f8e3b4', borderRadius: 0 }} size="small" label={values?.poStatus} />}
                    </span>
                  </div>
                ) : <div className=" text-xl mb-4 capitalize font-bold mt-6">Create New Agency PO</div>}
              <div
                onClick={() => { return setopenHeader(!openHeader); }}
                className="flex flex-row place-content-between mb-4  mt-4 bg-secondary-500 p-1 px-2.5 rounded-md  cursor-pointer"
              >
                <div className="text-base font-muli text-white-light  font-bold">Expense Details</div>
                  <img src={polygon} alt="polygon" className={`${!openHeader ? 'transform -rotate-90' : ''} w-6`} />
              </div>
              {openHeader && (
                <div className="grid grid-cols-3 gap-6 p-1 newDataError">
                  <Field
                    name="expenseCategoryId"
                    component={DropdownFieldComponent}
                    className="w-full"
                    options={expenseCategoryList}
                    rounded
                    dataObj = {dataObj}
                    requiredField
                    isDisabled={(disableHeader || dataObj?.poStatus ? dataObj.poStatus.toLowerCase() !== 'draft' : false) || (SYSTEM_GENERATED_CATEGORY_LIST.includes(dataObj?.expenseCategoryName))}
                    id="select1"
                    type="text"
                    placeholder=""
                    label="Expense Category"
                  />
                  <Field
                    name="vendorId"
                    component={DropdownFieldComponent}
                    className="w-full"
                    options={filteredVendorList}
                    rounded
                    requiredField
                    isDisabled={disableHeader || dataObj?.poStatus? dataObj?.poStatus.toLowerCase() !== 'draft' : false}
                    id="select1"
                    type="text"
                    placeholder=""
                    label="Vendor"
                  />
                  <Field
                  name="vendorAddress"
                  component={InputFieldComponent}
                  className="w-full"
                  id="number"
                  size="medium"
                  variant="text"
                  rounded
                  disabled
                  value={vendorAddress}
                  label="Vendor Address"
                />
                  <Field
                    name="companyId"
                    component={DropdownFieldComponent}
                    setChangedValue={(id)=>OnchangedCompanyValue(id,values)}
                    className="w-full"
                    options={companyList}
                    rounded
                    isDisabled={disableHeader || dataObj?.poStatus? dataObj?.poStatus.toLowerCase() !== 'draft' : false}
                    requiredField
                    id="select1"
                    type="text"
                    placeholder=""
                    label="Company"
                  />
                  <Field
                    name="budgetCategory"
                    component={DropdownFieldComponent}
                    className="w-full"
                    options={budgetCategoryList}
                    rounded
                    isDisabled={disableHeader}
                    id="select1"
                    type="text"
                    placeholder=""
                    label="Budget Category"
                    isClearable
                  />
                  {showHeaderSapPoNumber && (
                    <Field
                      name="sapPoNumber"
                      component={InputFieldComponent}
                      className="w-full"
                      id="sapPoNumber"
                      size="medium"
                      variant="text"
                      rounded
                      disabled
                      value={values?.sapPoNumber || dataObj?.sapPoNumber || '-'}
                      label="SAP PO Number"
                    />
                  )}
                  <Field
                    name="currencyId"
                    component={DropdownFieldComponent}
                    className="w-full"
                    options={currencyList}
                    rounded
                    requiredField
                    isDisabled={disableHeader || dataObj?.poStatus? dataObj?.poStatus.toLowerCase() !== 'draft' : false}
                    id="select1"
                    type="number"
                    placeholder=""
                    label="Currency"
                  />
                  <Field
                    name="purposeId"
                    component={DropdownFieldComponent}
                    className="w-full"
                    options={purposeLevelOneList}
                    rounded
                    isDisabled={disableHeader}
                    setFieldsNull={['purposeLevelId']}
                    id="select1"
                    type="text"
                    placeholder=""
                    label="Level 1 Purpose"
                    isClearable
                  />
                  <Field
                    name="purposeLevelId"
                    component={DropdownFieldComponent}
                    className="w-full"
                    options={purposeLevelTwoList}
                    rounded
                    isDisabled={disableHeader}
                    id="select1"
                    type="text"
                    placeholder=""
                    label="Level 2 Purpose"
                    isClearable
                  />
                    <Field
                    name="portId"
                    component={DropdownFieldComponent}
                    className="w-full"
                    options={portList}
                    rounded
                    isDisabled={
                      portsLoading ||
                      disableHeader ||
                      (dataObj?.poStatus
                        ? dataObj?.poStatus.toLowerCase() !== 'draft'
                        : false)
                    }
                    id="selectPort"
                    type="text"
                    placeholder=""
                    label="Port Name"
                    isClearable
                  />
                     <Field
                    key={`vessel-${values?.companyId ?? 'no-company'}`}
                    name="plannedVesselRevisionId"
                    component={DropdownFieldComponent}
                    special={selectedVessel}
                    className="w-full"
                    options={vesselListForSelect}
                    rounded
                    requiredField
                    isDisabled={disableHeader || dataObj?.poStatus? dataObj?.poStatus.toLowerCase() !== 'draft' : false}
                    customOnChange={(option, form) => {
                      form.setFieldValue('plannedVesselRevisionId', option?.value || '');
                      form.setFieldValue('plannedVesselId', option?.id || '');
                      form.setFieldValue('vesselName', option?.name || '');
                      form.setFieldValue('vesselCode', option?.vesselCode || '');
                      form.setFieldValue('imo', option?.imoNumber || '');
                      form.setFieldValue('sapVesselCompanyCode', option?.sapVesselCompanyCode || '');
                    }}
                    id="select1"
                    type="text"
                    placeholder=""
                    label="Vessel"
                  />
                    <Field
                    name="serviceCompletionDate"
                    component={InputFieldComponent}
                    className="w-full"
                    id="serviceCompletionDate"
                    type="date"
                    size="medium"
                    variant="text"
                    rounded
                    isDisabled={disableHeader || (dataObj?.poStatus
                      ? dataObj?.poStatus.toLowerCase() !== 'draft'
                      : false)}
                    label="Service Completion Date"
                  />
                </div>
              )}
               {(values?.vesselName || selectedVessel) && (
                <div className="mt-4 mb-4 flex flex-row justify-between p-4" style={{ border: '2px solid #EEEEEE', borderRadius: '10px' }}>
                  <div className="w-full md:w-1/4">
                    <span className="text-md"> Vessel Name :</span>
                    <span className="font-bold text-md">{values?.vesselName || selectedVessel?.name || '-'}</span>
                  </div>
                  <div className="w-full md:w-1/4">
                    <span className="text-md"> Vessel Code :</span>
                    <span className="font-bold text-md">{values?.vesselCode || selectedVessel?.vesselCode || '-'}</span>
                  </div>
                  <div className="w-full md:w-1/4">
                    <span className="text-md"> IMO :</span>
                    <span className="font-bold text-md">{values?.imo || selectedVessel?.imoNumber || '-'}</span>
                  </div>
                    <div className="w-full md:w-1/4">
                    <span className="text-md"> SAP Vessel Company Code :</span>
                    <span className="font-bold text-md">{values?.sapVesselCompanyCode || selectedVessel?.sapVesselCompanyCode || '-'}</span>
                  </div>
                </div>
              )}
                <VesselForm {...{ values, dataObj, mode, errors, touched, setFieldValue, expenseitemsData, vesselList: vesselListForSelect, expenseCategoryList,restoredPpeCategoryDetails,setRestoredPpeCategoryDetails,defaultCrewData, expenseItemList,companyId,setcreatedAccountCode,selectedDefaultCrewData,savedaccountCode}}setDefaultCrewData={setDefaultCrewData} setSavedAccountCode={setSavedAccountCode} plannedVesselRevisionId={values?.plannedVesselRevisionId} />
              
                <PoAttachments
                  name="attachments"
                  values={values}
                  setFieldValue={setFieldValue}
                  disabled={disableHeader || dataObj?.poStatus ? dataObj?.poStatus.toLowerCase() !== 'draft' : false}
                  companyId={values?.companyId}
                  expenseCategoryId={values?.expenseCategoryId}
                  poId={poId}
                  onUploadSuccess={(response) => {
                    const ids = response?.poAttachmentIds ?? [];
                    if (Array.isArray(ids) && ids.length > 0) {
                      const existing = values?.poAttachmentIds || [];
                      setFieldValue('poAttachmentIds', [...existing, ...ids]);
                    }
                  }}
                />
                 <div className=" p-1 newDataError">
                        <Field
                                  name="description"
                                  component={InputFieldComponent}
                                  className="w-full pt-3 text-base mb-4 "
                                  id="number"
                                  type="text"
                                  rounded
                                  disabled={disableHeader}
                                  autoComplete="off"
                                  label="Description"
                                  multiline
                                />
                                </div>
                  <AdvanceRequest
              values={values}
              setFieldValue={setFieldValue}
              validateForm={validateForm}
              errors={errors}
              mode={mode}
              disabled={disableHeader || (dataObj?.poStatus ? dataObj?.poStatus.toLowerCase() !== 'draft' : false)}
              paymentTermsOptions={[
                { label: 'Select', value: '' },
                ...(paymentTermsData?.data || []).map((t) => ({
                  label: t.description || t.paymentTerm || t.displayName || t.name || '',
                  value: t.id ?? '',
                  description: t.description,
                })),
              ]}
              poId={poId}
              companyId={values?.companyId}
              expenseCategoryId={values?.expenseCategoryId}
              agencyPOConfig={agencyPOConfig}
              onCancelAdvancePo={cancelAdvancePo}
              isCancelAdvancePoLoading={isCancelAdvancePoLoading}
            />
            <Level2Approver
              values={values}
              setFieldValue={setFieldValue}
              approverOptions={level2ApproverOptions}
              disabled={disableHeader}
              enableLevel2Approver={
                !!agencyPOConfig && (
                  values?.isAdvancePO === true
                    ? agencyPOConfig.isApprovalNeededForArqPo === true
                    : agencyPOConfig.isApprovalNeededForNormalPo === true
                )
              }
            />
             <ApprovalFlowLog
                poId={dataObj?.id ?? poId}
                approvals={values?.approvalLogs || []}
                disabled={disableHeader || (dataObj?.poStatus ? dataObj?.poStatus.toLowerCase() !== 'draft' : false)}
              />
               <div className=" p-1 newDataError">
                              <Field
                                name="logDescription"
                                component={InputFieldComponent}
                                className="w-full pt-3 text-base mb-4 "
                                id="number"
                                type="text"
                                rounded
                                disabled={disableHeader}
                                autoComplete="off"
                                label="Comments"
                                multiline
                              />
                              </div>
                
              </Form>
              </>
            );
          }}
        </Formik>
      </div>
                    {saveModal && (
                <DuplicateSave
                  modal={saveModal}
                  setModal={setSaveModal}
                  openDuplicate={openDuplicate}
                  handleSave={handleSave}
                  handleDraft={handleDraft(editPoValues || formValues)}
                  handleDiscard={handleDiscard}
                  duplicateData={duplicateData}
                  setisduplicateloading={setisduplicateloading}
                  poId={poId}
                  isPPE={
                    ['PPE', 'Vessel PPE'].some(label =>
                      expenseCategoryList?.find(item => item.label === label)?.value === editPoValues?.expenseCategoryId ||
                      expenseCategoryList?.find(item => item.label === label)?.value === editPoValues?.expenseCategoryId
                    )
                  }                />
              )}
      {mailModal && (
        <MailModal
          {...{
            mailModal,
            setMailModal,
            handleMail,
            cancelMail,
            currencyList,
            vesselList,
            isCrewPage: false,
            mailBasicInfo,
            setmailBasicInfo,
            formValues: formValues || editPoValues,
            filteredVendorList: mailVendorList
          }}
        />
      )}
      {showConfirmModal && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div className="bg-white rounded-lg shadow-lg p-6 w-[400px]">
      <div className="uppercase pb-4 text-center text-lg font-bold">Common Crew Confirmation</div>
      <label className="mb-6 text-base">
        You have selected <strong>Common Crew</strong>. Do you want to proceed?
      </label>
      <div className="flex justify-end gap-4">
      </div>
      <div className="flex flex-row float-right mt-4">
                            <div className="table-cell p-2">
                                <Button
                                    type="button"
                                    size="medium"
                                    variant="outlined"
                                    rounded
                                    className="w-18 text-xs h-10"
                                    onClick={() => {
                                      setShowConfirmModal(false);
                                      setPendingValues(null);
                                    }}                                >
                                    Cancel
                                </Button>
                            </div>
                            <div className="table-cell p-2">
                                <Button
                                    type="button"
                                    size="medium"
                                    variant="primary"
                                    rounded
                                    className="w-20 text-xs h-10"
                                    onClick={() => {
                                      if (pendingValues) {
                                        const updatedCrew = pendingValues.purchaseOrderCrew.map((crew, index) => {
                                          const code = getAccountCode(index, pendingValues);
                                          return {
                                            ...crew,
                                            accountCode: code || '',
                                          };
                                        });
                          
                                        const finalValues = {
                                          ...pendingValues,
                                          purchaseOrderCrew: updatedCrew,
                                        };
                                        setformValues(
                                          pendingValues?.purchaseOrderCrew?.length > 1 && mode === 'add'
                                            ? { ...finalValues, isBulkOrder: false }
                                            : finalValues
                                        );
                                        setPendingValues(null);
                                      }
                          
                                      setShowConfirmModal(false);
                                    }}
                                >
                                    Proceed
                                </Button>
                            </div>
                        </div>   
    </div>
  </div>
)}

    </>
  );
};

export default withMasterData(AgencyPOForm);